import axios from 'axios';
import {
  APP_SETTING_IMPORT_PROJECT_BEGIN,
  APP_SETTING_IMPORT_PROJECT_SUCCESS,
  APP_SETTING_IMPORT_PROJECT_FAILURE,
  APP_SETTING_IMPORT_PROJECT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceMultiPartHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';

export function importProject(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_IMPORT_PROJECT_BEGIN,
    });
    const { projectId, formData } = args;
    const header = builderSurfaceMultiPartHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}projects/core/${projectId}/import-project`,
        formData,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_IMPORT_PROJECT_SUCCESS,
            data: res,
          });
          resolve(res);
          toast.success('Project imported successfully!');
        },
        (err) => {
          dispatch({
            type: APP_SETTING_IMPORT_PROJECT_FAILURE,
            data: { error: err },
          });
          reject(err);
          toast.error('Project import failed! Please try again.');
        },
      );
    });

    return promise;
  };
}

export function dismissImportProjectError() {
  return {
    type: APP_SETTING_IMPORT_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_IMPORT_PROJECT_BEGIN:
      return {
        ...state,
        importProjectPending: true,
        importProjectError: null,
      };

    case APP_SETTING_IMPORT_PROJECT_SUCCESS:
      return {
        ...state,
        importProjectPending: false,
        importProjectError: null,
      };

    case APP_SETTING_IMPORT_PROJECT_FAILURE:
      return {
        ...state,
        importProjectPending: false,
        importProjectError: action.data.error,
      };

    case APP_SETTING_IMPORT_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        importProjectError: null,
      };

    default:
      return state;
  }
}
